import { RADIUS } from 'DesignTokens';
import React from 'react';
import { colors } from '../../web-polyfills/native-app-theme/colors';

export default function MobileAppPreviewLoading() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '24px 0',
        background: '#e8eaed',
        borderRadius: RADIUS.sectionChild,
        minHeight: '100%',
        color: colors.textSecondary,
      }}
    >
      Loading preview…
    </div>
  );
}
